import { Box, Grid, Text } from '@factorialco/deprecated-design-system'
import { AnimatePresence, motion } from 'framer-motion'
import { ListIntegrationFragment } from 'generated/resources/graphql'

import { IntegrationItemCard } from 'modules/marketplace/components/IntegrationItemCard'
import { useIntegrationsCatalog } from 'modules/marketplace/components/IntegrationList/IntegrationsCatalogProvider'
import { Category } from 'modules/marketplace/components/IntegrationList/integrationCatalogSorter'

interface CategoryProps {
  category: Category
}

export const CategoryItem = ({ category }: CategoryProps) => {
  const { installedIntegrations } = useIntegrationsCatalog()

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  }

  const isIntegrationInstalled = (integration: ListIntegrationFragment) => {
    return installedIntegrations.some(
      (installedIntegration) => installedIntegration === integration.id
    )
  }

  return (
    <Box flexDirection="row" paddingBottom="s64" key={category.id} width="full">
      <Box flexDirection="column" gap="s24" justifyContent="flexStart" width="full">
        <Text weight="medium" size="500" color="grey1000">
          {category.title}
        </Text>
        <AnimatePresence>
          <motion.div layout variants={container} initial="hidden" animate="show">
            <Grid variant="large">
              {category.children.map((integration) => (
                <IntegrationItemCard
                  key={integration.datoId}
                  integration={integration}
                  installed={isIntegrationInstalled(integration)}
                />
              ))}
            </Grid>
          </motion.div>
        </AnimatePresence>
      </Box>
    </Box>
  )
}
